import { TaskItem, TaskList as TiptapTaskList } from '@tiptap/extension-list'

import { TaskListActionButton } from '@/tiptap/extensions/components/ActionButton'

export const TaskList = TiptapTaskList.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      HTMLAttributes: {
        class: 'task-list',
      },
      taskItem: {
        HTMLAttributes: {
          class: 'task-list-item',
        },
      },
      button: ({ editor, t }) => ({
        component: TaskListActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },

  addExtensions() {
    return [TaskItem.configure(this.options.taskItem)]
  },
})

export default TaskList
